@if (contact) {
  <div class="avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="contact.avatar?.url ?? ''"
                [name]="contact.fullName"
    ></app-avatar>
  </div>
  <div class="user-info">
    <h3 class="name">{{ contact.fullName }}</h3>
    <p class="username"> {{ contact.email || contact.phone }}</p>
  </div>

  <div class="actions">
    <div class="icon">
      <app-icon size="medium" *ngIf="!contact.email" name="email"></app-icon>
    </div>
    <div class="more">
      @if (contact) {
        <button class="friends-menu-button" (click)="onMenuClick($event)" mat-button [matMenuTriggerFor]="menu">
          <app-icon class="icon" name="heroEllipsisHorizontal"></app-icon>
        </button>
        <mat-menu class="actions" #menu="matMenu">
          @if (!contact.email) {
            <button (click)="addEmail()" class="menu-item default" mat-menu-item>Add email</button>
          } @else {
            <button (click)="sendInvite()" class="menu-item" mat-menu-item>Send invite</button>
          }

          <button (click)="removeFromList()" class="menu-item delete-item" mat-menu-item>Remove from this list</button>
        </mat-menu>
      }
    </div>
  </div>
}
